'use strict';

import React from 'react';

import HomeSearchBase from './HomeSearchBase';
import {SALE, RENT, APARTMENTS, RENTDAILY, REALTY_TYPES} from '../../../consts';
import ExtendSearch from '../ExtendSearch/RentApartments';


class RentApartments extends HomeSearchBase {
  constructor (props) {
    super(props);

    const d = this.getDictionary();

    this.dealTypes = d.getDealTypeItems(SALE, APARTMENTS);
    this.objectTypes = {
      [SALE]: d.getObjectTypeItems(SALE, APARTMENTS),
      [RENT]: d.getObjectTypeItems(RENT, APARTMENTS).filter(item => {
        return [REALTY_TYPES.house, REALTY_TYPES.cottage, REALTY_TYPES.townHouse].indexOf(item.id) === -1;
      }),
      [RENTDAILY]: d.getObjectTypeItems(RENTDAILY, APARTMENTS).filter(item => {
        return [REALTY_TYPES.house, REALTY_TYPES.cottage, REALTY_TYPES.townHouse].indexOf(item.id) === -1;
      })
    };
  }

  getRealtyType () {
    return APARTMENTS;
  }

  getQuickSearchBody (className) {
    return (
      <div className='quick-search-controls'>
        <div className='quick-search-controls__search-menu'>
          <div className={className + ' quick-search-rent-apartments'}>
            { this.renderDealType(this.dealTypes)}
            { this.renderObjectType(this.objectTypes[this.state.dealType], 'Тип жилья') }
            { this.renderTerritorialDivision() }
            { this.renderAutocompleteLocation() }
            { this.renderPriceGroup(true) }
          </div>
        </div>
        <div className='quick-search-controls__extended-search'>
          { this.renderExtendSearch(ExtendSearch) }
        </div>
      </div>
    );
  }
}

export default RentApartments;



// WEBPACK FOOTER //
// ./src/ui/Search/HomeSearch/RentApartments.jsx